import type { LeaseActionProps } from '../../../models/Types';
import { ZILLOW_LEASES_TENANT_HELP } from '../../../constants/stringConstants';

export default function OpenTabTenantHelpLink({ terminateActiveAction }: LeaseActionProps) {
  window.open(ZILLOW_LEASES_TENANT_HELP, '_blank');
  terminateActiveAction();
  return null;
}
